import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { EntityStageConfigurationDto, EntityStageConfigurationList, AuthorityDTO } from "./entity-stage-configuration.dto";
import { map, Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class EntityStageConfigurationService {
  constructor(private http: HttpClient) {}

  findRecords(sort, pageIndex = 0, pageSize, columnName, columnValue): Observable<EntityStageConfigurationList> {
    let params = new HttpParams().set("page", pageIndex).set("size", pageSize).set("sort", sort);
    if (columnName && columnValue) {
      params = params.set(columnName, columnValue);
    }
    return this.http
      .get<EntityStageConfigurationDto[]>(`api/application/configurations/search`, {
        observe: "response",
        params: params,
      })
      .pipe(
        map((response) => {
          return { data: response.body, totalCount: +response.headers.get("X-Total-Count") };
        }),
      );
  }

  saveEntityStageConfigurations(entityStageConfiguration: EntityStageConfigurationDto): Observable<EntityStageConfigurationDto> {
    return this.http.post<EntityStageConfigurationDto>(`api/application/configurations`, entityStageConfiguration).pipe(map((response) => response));
  }

  updateEntityStageConfigurations(entityStageConfiguration: EntityStageConfigurationDto): Observable<EntityStageConfigurationDto> {
    return this.http.put<EntityStageConfigurationDto>(`api/application/configurations`, entityStageConfiguration).pipe(map((response) => response));
  }

  addEntityStageConfigurations(entityStageConfiguration: EntityStageConfigurationDto): Observable<EntityStageConfigurationDto> {
    return this.http.post<EntityStageConfigurationDto>(`api/application/configurations`, entityStageConfiguration).pipe(map((response) => response));
  }

  getById(id: string): Observable<EntityStageConfigurationDto> {
    return this.http.get<EntityStageConfigurationDto>(`api/application/configurations/${id}`).pipe(map((response) => response));
  }

  uploadFile(file: File): Observable<EntityStageConfigurationDto> {
    return this.http.post<EntityStageConfigurationDto>(`api/application/configurations`, file).pipe(map((response) => response));
  }

  getAuthority(): Observable<AuthorityDTO[]> {
    return this.http.get<AuthorityDTO[]>(`api/application/configurations`);
  }

  getEntityStageByProductCategory(productCtaegory: String): Observable<EntityStageConfigurationDto[]> {
    return this.http.get<EntityStageConfigurationDto[]>(`api/application/configuration-productCategory/${productCtaegory}`);
  }

  getAsMapByProductCategory(productCtaegory: String): Observable<Map<string, EntityStageConfigurationDto>> {
    return this.http.get<Map<string, EntityStageConfigurationDto>>(`api/application/entity-configuration/as-map/${productCtaegory}`);
  }
  findAllOrderByOrderAsc(): Observable<EntityStageConfigurationDto[]> {
  return this.http.get<EntityStageConfigurationDto[]>(`api/application/configurations/order-asc`);
}

}
